import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f81b4d40"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tier-template-switch"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "template-title"
}, "设为层级模板", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "template-tips"
}, " 开启后，本次配置的国家-层级映射将保存为默认模板，新建同渠道商品时自动沿用，其余价格字段仍需重新填写。 ", -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export default /*#__PURE__*/_defineComponent({
  __name: 'TierTemplateSwitch',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    // 点击文字区域切换开关（与 GST 调价交互一致）
    const onToggle = () => {
      if (props.disabled) return;
      emit('update:modelValue', !props.modelValue);
    };
    return (_ctx, _cache) => {
      const _component_a_switch = _resolveComponent("a-switch");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_switch, {
        checked: __props.modelValue,
        disabled: __props.disabled,
        onChange: _cache[0] || (_cache[0] = val => emit('update:modelValue', val))
      }, null, 8, ["checked", "disabled"]), _createElementVNode("div", {
        class: _normalizeClass(["template-text", {
          disabled: __props.disabled
        }]),
        onClick: onToggle
      }, _hoisted_4, 2)]);
    };
  }
});